import styled from "@emotion/styled";
import Sidebar from "../sidebar";
import React, {ReactNode, useState} from "react";
import TopBar from "../topbar";
import {DrawerType} from "../../types/types";
import RightDrawers from "../sidebar/RightDrawers";

export const PublicLayout = ({children}: { children: ReactNode }) => {
  const [rightDrawerType, setRightDrawerType] = useState<DrawerType>();

  return (
    <Layout>
      <RightDrawers drawerType={rightDrawerType} openDrawer={setRightDrawerType}/>
      <TopBar drawerType={rightDrawerType} openDrawer={setRightDrawerType}/>
      <Sidebar/>
      <Content>
        {children}
      </Content>
    </Layout>
  );
}

const Layout = styled.div`
  display: flex;
  justify-content: space-between;
  text-align: center;
  margin-top: 80px;
  height: calc(100vh - 80px);
  overflow: hidden;
`;

const Content = styled.div`
  position: relative;
  display: block;
  height: 100%;
  flex: 1;
  overflow: auto;
`;